module.exports = __webpack_public_path__ + "static/media/contact.f320acd6.svg";